import type { EffectProps } from "./types";

export function RainbowPulse(_props: EffectProps = {}) {
  return <div className="fx-rainbow-bg" aria-hidden />;
}
